var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrayCopyIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 2H10.2333C11.7268 2 12.4735 2 13.044 2.29065C13.5457 2.54631 13.9537 2.95426 14.2094 3.45603C14.5 4.02646 14.5 4.77319 14.5 6.26667V11M4.63333 14H10.0333C10.7801 14 11.1534 14 11.4387 13.8547C11.6895 13.7268 11.8935 13.5229 12.0213 13.272C12.1667 12.9868 12.1667 12.6134 12.1667 11.8667V6.46667C12.1667 5.71993 12.1667 5.34656 12.0213 5.06135C11.8935 4.81046 11.6895 4.60649 11.4387 4.47866C11.1534 4.33333 10.7801 4.33333 10.0333 4.33333H4.63333C3.8866 4.33333 3.51323 4.33333 3.22801 4.47866C2.97713 4.60649 2.77316 4.81046 2.64532 5.06135C2.5 5.34656 2.5 5.71993 2.5 6.46667V11.8667C2.5 12.6134 2.5 12.9868 2.64532 13.272C2.77316 13.5229 2.97713 13.7268 3.22801 13.8547C3.51323 14 3.8866 14 4.63333 14Z",
    stroke: "#434343",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayCopyIcon);
export default __webpack_public_path__ + "static/media/gray-copy-icon.df68e3422e15e0baa8910189bf8e427e.svg";
export { ForwardRef as ReactComponent };